import React from "react";

/**
 * ChangeChipList — forecast_movement evidence component.
 *
 * One chip per date whose rain outlook moved 15+ points in 48 hours.
 * Green for improved, amber for deteriorated. No chart.
 *
 * Spec references: §7 (forecast_movement).
 */

/** Short date — "Aug 10" */
const shortDate = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr + "T00:00:00");
  if (Number.isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

const ChangeChipList = ({ panel }) => {
  const f = panel.facts || {};
  const sortedDates = [...(f.dates || [])].sort((a, b) =>
    a.date.localeCompare(b.date)
  );

  if (sortedDates.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-3">
      {sortedDates.map((d) => {
        const isImproved = d.direction === "improved";
        return (
          <div
            key={d.date}
            className={`inline-flex items-center gap-2 px-3 py-2 rounded-lg border text-sm ${
              isImproved
                ? "bg-green-50 border-green-200 text-green-700 dark:bg-green-900/20 dark:border-green-800 dark:text-green-400"
                : "bg-orange-50 border-orange-200 text-orange-700 dark:bg-orange-900/20 dark:border-orange-800 dark:text-orange-400"
            }`}
          >
            {/* Direction arrow */}
            <span className="text-lg leading-none">
              {isImproved ? "↓" : "↑"}
            </span>

            {/* Date */}
            <span className="font-semibold">{shortDate(d.date)}</span>

            {/* Rain change */}
            <span className="text-xs opacity-75">
              {d.precip_prob_48h_ago}% → {d.precip_prob_now}%
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default ChangeChipList;
